/* ===== art/items/ui.js — UI · 탭 아이콘 · 새 게임 창 ===== */
import { TAU } from '../../../engine/core/math.js';
import { ITEM_PAINT, sh2 } from '../../itemart.js';
/* itemart.js Art.paint 의 갈래들 — 읽히는 순간 ITEM_PAINT 에 붙는다. H 는 paint 의 인자·도우미 묶음, this 는 Art. */

export const ItemPaintUI: Bag = {
  /* ---------- UI ---------- */
  sun(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        glow(16, 16, 13, '#ffe9a8', .3);
        circ(16, 16, 8, '#ffdf80');
        circ(16, 16, 6, '#fff0c0');
        for (let i = 0; i < 8; i++) {
          const a = i * TAU / 8;
          stroke('#ffdf80', 2.2, () => {
            g.moveTo(16 + Math.cos(a) * 10, 16 + Math.sin(a) * 10);
            g.lineTo(16 + Math.cos(a) * 14, 16 + Math.sin(a) * 14);
          });
        }
        return;
      }
    }
  },
  moon(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        glow(16, 16, 12, '#dfe8f5', .2);
        circ(15, 16, 10, '#dfe8f5');
        circ(20, 13, 9, 'rgba(0,0,0,0)');
        g.globalCompositeOperation = 'destination-out';
        circ(21, 13, 9, '#000');
        g.globalCompositeOperation = 'source-over';
        circ(11, 19, 1.8, '#c2cddd'); circ(14, 12, 1.3, '#c2cddd');
        return;
      }
    }
  },
  coin(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        circ(16, 16, 11, '#c8952a');
        circ(16, 16, 9, '#e8c04a');
        circ(16, 16, 6.5, '#d8a93a');
        P(14.6, 10, 2.8, 12, '#f5deA0');
        P(11, 14.6, 10, 2.8, '#f5dea0');
        ell(12, 11, 2.6, 1.6, 'rgba(255,255,255,.45)');
        return;
      }
    }
  },
  chat(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        g.fillStyle = '#e8dcc0'; g.beginPath();
        g.moveTo(5, 6); g.lineTo(27, 6); g.lineTo(27, 21); g.lineTo(15, 21);
        g.lineTo(10, 27); g.lineTo(10, 21); g.lineTo(5, 21); g.closePath(); g.fill();
        circ(11, 13.5, 1.8, '#4a4438'); circ(16, 13.5, 1.8, '#4a4438'); circ(21, 13.5, 1.8, '#4a4438');
        return;
      }
    }
  },
  bagui(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 소지품 — 열린 자루.
        glow(16, 17, 12, '#d8a94b', .13);
        poly([[8, 12], [24, 12], [26, 27], [6, 27]], '#8c7651');
        poly([[8, 12], [16, 12], [16, 27], [6, 27]], '#c8aa70');
        poly([[6, 12], [10, 6], [22, 6], [26, 12]], '#5c4930');   // 젖혀진 덮개
        P(13, 17, 6, 5, '#5c4930');                                // 잠금쇠
        return;
      }
    }
  },
  /* ---- 탭 아이콘 — 금빛(#c8aa70) 밝은 면 · 가죽빛(#8c7651) 그늘 · 짙은 갈색(#5c4930) 선, 은은한 금빛 번짐 ---- */
  pskill(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 능력과 특성 — 네 갈래로 빛나는 별(특성 나무의 끝)
        glow(16, 16, 13, '#d8a94b', .16);
        poly([[16, 3], [19.5, 12.5], [29, 16], [19.5, 19.5], [16, 29], [12.5, 19.5], [3, 16], [12.5, 12.5]], '#8c7651');
        poly([[16, 3], [19.5, 12.5], [16, 16], [12.5, 12.5]], '#e8cf8e');
        poly([[3, 16], [12.5, 12.5], [16, 16], [12.5, 19.5]], '#c8aa70');
        circ(16, 16, 3, '#fff0c0');
        return;
      }
    }
  },
  pquest(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 여정의 기록 — 펼친 책과 책갈피
        glow(16, 17, 12, '#d8a94b', .13);
        poly([[4, 9], [16, 11], [16, 27], [4, 25]], '#c8aa70');
        poly([[28, 9], [16, 11], [16, 27], [28, 25]], '#e0c890');
        P(15, 11, 2, 16, '#5c4930');
        for (let i = 0; i < 4; i++) { P(6.5, 14 + i * 3, 7, 1.2, '#8c7651'); P(18.5, 14 + i * 3, 7, 1.2, '#a88a5a'); }
        poly([[22, 9.5], [25, 9.2], [25, 18], [23.5, 16.5], [22, 18]], '#b8483c');   // 책갈피
        return;
      }
    }
  },
  pcraft(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 제작 — 망치와 톱이 엇갈린 문장
        glow(16, 16, 12, '#d8a94b', .13);
        stroke('#5c4930', 3, () => { g.moveTo(8, 26); g.lineTo(21, 11); });
        poly([[17, 6], [27, 12], [24, 16], [14, 10]], '#8c7651');
        poly([[17, 6], [27, 12], [26, 13.5], [16, 7.5]], '#c8aa70');
        stroke('#5c4930', 3, () => { g.moveTo(24, 26); g.lineTo(11, 11); });
        poly([[6, 8], [12, 5], [15, 12], [9, 15]], '#9fb0bc');
        for (let i = 0; i < 3; i++) P(6.5 + i * 2.2, 13.5 - i * 1.1, 1.3, 1.3, '#5d7892');
        return;
      }
    }
  },
  pchest(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 상자 — 둥근 뚜껑과 쇠 띠
        glow(16, 17, 12, '#d8a94b', .12);
        P(5, 14, 22, 13, '#8c7651'); P(5, 14, 11, 13, '#a88a5a');
        poly([[5, 14], [7, 8], [25, 8], [27, 14]], '#c8aa70');
        P(5, 13.2, 22, 2, '#5c4930'); P(9, 8, 2, 19, '#5c4930'); P(21, 8, 2, 19, '#5c4930');
        P(14, 15, 4, 5, '#e8cf8e'); P(15.2, 17, 1.6, 2, '#5c4930');
        return;
      }
    }
  },
  pvault(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 보관고 — 둥근 손잡이가 달린 금고 문
        glow(16, 16, 12, '#d8a94b', .12);
        P(5, 6, 22, 21, '#5c4930'); P(6.5, 7.5, 19, 18, '#8c7651');
        circ(16, 16.5, 6, '#c8aa70'); circ(16, 16.5, 3.5, '#5c4930'); circ(16, 16.5, 1.5, '#e8cf8e');
        for (let i = 0; i < 4; i++) { const a = i * Math.PI / 2 + .6; P(16 + Math.cos(a) * 6.5 - .8, 16.5 + Math.sin(a) * 6.5 - .8, 1.6, 1.6, '#e8cf8e'); }
        P(8, 27, 3, 2, '#5c4930'); P(21, 27, 3, 2, '#5c4930');
        return;
      }
    }
  },
  pboard(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 의뢰 게시판 — 기둥 둘에 핀으로 꽂힌 쪽지 셋
        glow(16, 16, 12, '#d8a94b', .12);
        P(7, 6, 2.5, 23, '#5c4930'); P(22.5, 6, 2.5, 23, '#5c4930');
        P(5, 7, 22, 14, '#8c7651');
        P(7, 9, 7, 8, '#e8dcc0'); P(15.5, 8.5, 8, 6, '#e0c890'); P(16, 15.5, 7, 4, '#e8dcc0');
        circ(10.5, 9.5, 1, '#b8483c'); circ(19.5, 9, 1, '#b8483c'); circ(19.5, 16, 1, '#b8483c');
        return;
      }
    }
  },
  ptown(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 여명 마을 — 지붕과 굴뚝, 불 켜진 창
        glow(16, 17, 12, '#d8a94b', .13);
        P(7, 15, 18, 12, '#8c7651'); P(7, 15, 9, 12, '#a88a5a');
        poly([[4, 16], [16, 5], [28, 16]], '#b8483c'); poly([[4, 16], [16, 5], [16, 16]], '#d0685a');
        P(21, 7, 3, 6, '#5c4930');
        P(10, 18, 4, 4, '#ffd98a'); P(18, 19, 4, 8, '#5c4930');
        return;
      }
    }
  },
  pmach(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 기계 — 톱니바퀴
        glow(16, 16, 12, '#d8a94b', .12);
        for (let i = 0; i < 8; i++) { const a = i * Math.PI / 4; g.save(); g.translate(16 + Math.cos(a) * 10, 16 + Math.sin(a) * 10); g.rotate(a); g.fillStyle = '#8c7651'; g.fillRect(-2.5, -2.5, 5, 5); g.restore(); }
        circ(16, 16, 10, '#8c7651'); circ(16, 16, 8.5, '#c8aa70'); circ(16, 16, 4, '#5c4930'); circ(16, 16, 2, '#e8cf8e');
        return;
      }
    }
  },
  preforge(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 재련대 — 받침 위의 불꽃
        glow(16, 15, 12, '#ff9a50', .2);
        poly([[16, 3], [22, 12], [21, 19], [11, 19], [10, 12]], '#e0561c');
        poly([[16, 8], [19, 14], [18, 19], [14, 19], [13, 14]], '#ffb24a');
        poly([[16, 12], [17.5, 16], [16, 19], [14.5, 16]], '#fff0c0');
        P(7, 20, 18, 3, '#8c7651'); P(10, 23, 12, 5, '#5c4930');
        return;
      }
    }
  },
  panvil(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 강화 모루 — 뿔 달린 모루와 불티
        glow(16, 18, 12, '#d8a94b', .13);
        poly([[5, 12], [24, 12], [27, 15], [22, 17], [9, 17]], '#9fb0bc');
        poly([[5, 12], [24, 12], [24, 14], [7, 14]], '#d8e0e8');
        P(12, 17, 8, 5, '#6d7a86'); P(9, 22, 14, 5, '#5c6670');
        circ(22, 7, 1.2, '#ffb24a'); circ(18, 5, 0.9, '#ffd98a'); circ(25, 9, 0.8, '#ffd98a');
        return;
      }
    }
  },
  pmap(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 지도 — 세 번 접힌 종이, 점선 길과 X 표
        glow(16, 16, 12, '#d8a94b', .12);
        poly([[4, 8], [12, 6], [20, 8], [28, 6], [28, 25], [20, 27], [12, 25], [4, 27]], '#c8aa70');
        poly([[12, 6], [20, 8], [20, 27], [12, 25]], '#a88a5a');
        for (let i = 0; i < 5; i++) P(7 + i * 3.4, 20 - i * 1.8, 1.8, 1.4, '#5c4930');
        stroke('#b8483c', 1.8, () => { g.moveTo(22, 10); g.lineTo(26, 14); g.moveTo(26, 10); g.lineTo(22, 14); });
        return;
      }
    }
  },
  ng(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        const G1 = '#c8aa70', G2 = '#8c7651', DK = '#5c4930', c = s.c || G1;
        glow(16, 16, 12, s.c || '#d8a94b', .14);
        switch (s.g) {
          case 'shield':                                   // 일반 — 방패
            poly([[6, 6], [26, 6], [25, 18], [16, 28], [7, 18]], sh2(c, .7));
            poly([[6, 6], [16, 6], [16, 28], [7, 18]], c);
            P(15, 9, 2, 15, sh2(c, 1.35)); P(10, 14, 12, 2, sh2(c, 1.35));
            break;
          case 'swords':                                   // 하드 — 방패 뒤로 엇갈린 두 검
            for (const d of [1, -1]) stroke('#d8dce4', 2.4, () => { g.moveTo(16 - 12 * d, 4); g.lineTo(16 + 10 * d, 26); });
            for (const d of [1, -1]) { P(16 + 8 * d - 2, 22, 4, 2, DK); }
            poly([[10, 11], [22, 11], [21.5, 19], [16, 25], [10.5, 19]], sh2(c, .7));
            poly([[10, 11], [16, 11], [16, 25], [10.5, 19]], c);
            break;
          case 'skull':                                    // 불가능 — 해골
            ell(16, 13, 10, 9, '#e8e0cc');
            P(10, 18, 12, 8, '#e8e0cc');
            ell(12, 14, 2.8, 3.2, c); ell(20, 14, 2.8, 3.2, c);
            poly([[16, 17], [17.6, 20.5], [14.4, 20.5]], DK);
            for (let i = 0; i < 4; i++) P(11.5 + i * 2.6, 23, 1.2, 3, DK);
            P(10, 18, 12, 1, sh2('#e8e0cc', .8));
            break;
          case 'land': {                                   // 세계 크기 — 둥근 창 속 땅의 폭이 커진다(섬 → 대륙)
            g.save(); g.beginPath(); g.arc(16, 16, 13, 0, TAU); g.clip();
            P(0, 0, 32, 32, '#9fc4dc'); P(0, 19, 32, 13, '#3f6f94');          // 하늘 · 바다
            const hw = [0, 5, 9.5, 16][s.n], top = [0, 13, 10, 5][s.n];
            poly([[16 - hw, 21], [16 - hw * .55, 16], [16, top], [16 + hw * .55, 16], [16 + hw, 21], [16 + hw, 32], [16 - hw, 32]], '#6f9a4a');
            poly([[16 - hw, 21], [16 - hw * .55, 16], [16, top], [16, 32], [16 - hw, 32]], '#8fbf5a');
            if (s.n === 3) {                                                  // 대형 — 설산 봉우리 둘 더
              poly([[16, top], [13.4, top + 4], [18.6, top + 4]], '#eef4f8');
              poly([[5, 21], [8.5, 11], [12, 21]], '#5f8a40'); poly([[20, 21], [24, 12], [28, 21]], '#5f8a40');
            }
            P(16 - hw - 1, 21, hw * 2 + 2, 1.6, '#c8ab6a');                    // 물가 모래
            g.restore();
            stroke(G2, 1.8, () => { g.arc(16, 16, 13, 0, TAU); });
            break;
          }
          case 'hood':                                     // 캐릭터 — 두건 쓴 머리
            poly([[16, 4], [26, 14], [25, 28], [7, 28], [6, 14]], G2);
            poly([[16, 4], [16, 28], [7, 28], [6, 14]], G1);
            ell(16, 17, 5.5, 6.5, '#2a2218');
            P(13, 16, 2, 1.6, '#e8dcc0'); P(17.5, 16, 2, 1.6, '#e8dcc0');
            break;
          case 'sword':                                    // 검 — 난이도 소제목 · 싱글플레이
            poly([[16, 3], [19, 7], [19, 21], [13, 21], [13, 7]], '#d8dce4');
            poly([[16, 3], [16, 21], [13, 21], [13, 7]], '#f2f4f8');
            P(9, 21, 14, 3, G2); P(9, 21, 14, 1.2, G1);
            P(14.5, 24, 3, 5, DK); circ(16, 29.5, 1.8, G1);
            break;
          case 'globe':                                    // 세계 — 지구본
            circ(16, 16, 12, '#5a86a8'); circ(16, 16, 10.6, '#7fb0d0');
            poly([[9, 10], [15, 8], [17, 13], [13, 17], [8, 15]], '#8fbf5a');
            poly([[18, 17], [24, 16], [25, 21], [19, 24]], '#8fbf5a');
            stroke('#5a86a8', 1, () => { g.ellipse(16, 16, 5, 11, 0, 0, TAU); g.moveTo(5, 16); g.lineTo(27, 16); });
            stroke(G2, 1.6, () => { g.arc(16, 16, 12, 0, TAU); });
            break;
          case 'quill':                                    // 이름 — 깃펜
            poly([[25, 3], [28, 6], [14, 22], [10, 22], [10, 18]], '#e8e0cc');
            poly([[25, 3], [10, 18], [10, 22]], '#c8c0ac');
            stroke(DK, 1.4, () => { g.moveTo(24, 6); g.lineTo(11, 21); });
            poly([[10, 22], [6, 28], [8, 23]], '#3a3228');
            P(5, 28, 16, 1.6, G2);
            break;
          case 'seed':                                     // 세계 씨앗 — 싹 튼 씨
            ell(16, 21, 7, 6, G2); ell(14.5, 19.5, 4, 3.4, G1);
            stroke('#6f9a4a', 2, () => { g.moveTo(16, 16); g.quadraticCurveTo(16, 10, 18, 7); });
            ell(21, 7.5, 4, 2.2, '#8fbf5a'); ell(12.5, 10, 3.4, 2, '#6f9a4a');
            break;
          case 'jump':                                     // 터치 점프 — 날개 단 위 화살
            for (const d of [1, -1]) poly([[16, 14], [16 + 12 * d, 10], [16 + 13 * d, 14], [16 + 9 * d, 18], [16 + 4 * d, 20]], d > 0 ? G2 : G1);
            poly([[16, 3], [24, 12], [19, 12], [19, 28], [13, 28], [13, 12], [8, 12]], '#e8dcc0');
            poly([[16, 3], [16, 28], [13, 28], [13, 12], [8, 12]], '#fff6e0');
            break;
          case 'dash':                                     // 터치 대시 — 앞으로 내딛는 장화 · 바람 줄
            for (let i = 0; i < 3; i++) P(2 + i * 2, 9 + i * 6, 9 - i * 2, 2, i === 1 ? '#e8dcc0' : G2);
            poly([[14, 5], [21, 5], [21, 18], [29, 21], [29, 26], [12, 26], [12, 18]], G2);
            poly([[14, 5], [17, 5], [17, 26], [12, 26], [12, 18]], G1);
            P(12, 24, 17, 2.4, DK); P(14, 9, 7, 1.6, DK);
            break;
          case 'hand':                                     // 터치 '사용' — 펼친 손
            for (let i = 0; i < 4; i++) { P(9 + i * 4, 5 + Math.abs(1.5 - i) * 2, 3.2, 12, i % 2 ? G1 : '#e8dcc0'); circ(10.6 + i * 4, 5 + Math.abs(1.5 - i) * 2, 1.6, i % 2 ? G1 : '#e8dcc0'); }
            poly([[8, 15], [25, 15], [25, 23], [20, 29], [11, 29], [8, 23]], '#e8dcc0');
            poly([[8, 15], [5, 10], [3, 12], [7, 21]], G1);
            P(10, 24, 13, 1.4, G2);
            break;
          case 'pick':                                     // 터치 '공격 · 캐기' — 곡괭이와 검이 엇갈린다
            stroke('#8a6a40', 2.8, () => { g.moveTo(8, 27); g.lineTo(22, 8); });
            poly([[13, 4], [28, 9], [27, 12], [20, 9], [14, 7]], '#c8ccd4');
            stroke('#d8dce4', 2.4, () => { g.moveTo(6, 6); g.lineTo(24, 26); });
            P(20, 21, 6, 2, G2); P(23, 24, 3, 4, DK);
            break;
          case 'expand':                                   // 전체 화면 — 네 귀퉁이
            for (const [x, y, dx, dy] of [[5, 5, 1, 1], [27, 5, -1, 1], [5, 27, 1, -1], [27, 27, -1, -1]] as const)
              stroke(G1, 3, () => { g.moveTo(x, y + 8 * dy); g.lineTo(x, y); g.lineTo(x + 8 * dx, y); });
            stroke(G2, 1.4, () => { g.rect(11, 11, 10, 10); });
            break;
          case 'play':                                     // 시작 · 이어하기
            poly([[9, 5], [26, 16], [9, 27]], G2);
            poly([[9, 5], [26, 16], [9, 16]], G1);
            break;
          case 'cross':                                    // 취소
            for (const d of [1, -1]) stroke(G2, 4, () => { g.moveTo(8, 16 - 8 * d); g.lineTo(24, 16 + 8 * d); });
            stroke(G1, 1.6, () => { g.moveTo(8, 8); g.lineTo(24, 24); });
            break;
          case 'compass': {                                // 새로운 여정 — 나침반
            circ(16, 16, 12, G2); circ(16, 16, 10, '#2a2218');
            poly([[16, 6], [19, 16], [13, 16]], '#d0564c');
            poly([[16, 26], [19, 16], [13, 16]], '#e8e0cc');
            circ(16, 16, 1.6, G1);
            for (let i = 0; i < 4; i++) { const a = i * Math.PI / 2; P(16 + Math.cos(a) * 11 - 1, 16 + Math.sin(a) * 11 - 1, 2, 2, G1); }
            break;
          }
          case 'gear': {                                   // 설정 — 톱니바퀴
            for (let i = 0; i < 8; i++) {
              const a = i * Math.PI / 4;
              g.save(); g.translate(16, 16); g.rotate(a); P(-2.5, -14, 5, 6, G2); g.restore();
            }
            circ(16, 16, 10, G2); circ(16, 16, 8.4, G1); circ(16, 16, 3.6, '#2a2218');
            break;
          }
          case 'scroll':                                   // 크레딧 — 두루마리
            P(8, 7, 16, 18, '#e8dcc0');
            for (let i = 0; i < 4; i++) P(11, 11 + i * 3.5, 10 - (i % 2) * 3, 1.3, '#8c7651');
            ell(8, 7, 3, 2.4, G2); P(5, 5, 22, 4, G2); P(5, 5, 22, 1.4, G1);
            P(5, 24, 22, 4, G2); P(5, 24, 22, 1.4, G1);
            break;
          case 'door':                                     // 나가기 — 열린 문
            P(7, 4, 16, 25, '#2a2218');
            P(7, 4, 16, 2, G2); P(7, 4, 2, 25, G2); P(21, 4, 2, 25, G2);
            poly([[9, 6], [17, 9], [17, 30], [9, 27]], G1);
            poly([[13, 9], [17, 9], [17, 30], [13, 28]], G2);
            circ(15, 19, 1.1, DK);
            stroke('#e8dcc0', 2, () => { g.moveTo(22, 16); g.lineTo(29, 16); g.moveTo(26, 13); g.lineTo(29, 16); g.lineTo(26, 19); });
            break;
          case 'disk':                                     // 저장 — 디스켓
            P(5, 5, 22, 22, G2); P(5, 5, 22, 1.4, G1);
            P(10, 5, 12, 8, '#d8dce4'); P(18, 6.5, 2.4, 5, '#5a6470');
            P(8, 17, 16, 10, '#e8dcc0'); for (let i = 0; i < 2; i++) P(10, 20 + i * 3, 12, 1.2, '#8c7651');
            break;
          case 'export':                                   // 내보내기 — 상자에서 나가는 화살
            P(5, 12, 16, 16, G2); P(7, 14, 12, 12, '#2a2218');
            stroke('#e8dcc0', 2.6, () => { g.moveTo(12, 20); g.lineTo(25, 7); });
            poly([[27, 4], [27, 13], [18, 4]], '#e8dcc0');
            break;
          case 'home':                                     // 타이틀로 — 집
            poly([[16, 4], [29, 15], [3, 15]], G2); poly([[16, 4], [16, 15], [3, 15]], G1);
            P(6, 15, 20, 13, G2); P(6, 15, 10, 13, G1); P(13, 19, 6, 9, '#2a2218');
            break;
          case 'speaker':                                  // 화면 · 소리 — 확성기와 물결
            P(4, 12, 6, 8, G1); poly([[10, 12], [17, 6], [17, 26], [10, 20]], G2);
            for (const r of [5, 9]) stroke(G1, 1.8, () => { g.arc(18, 16, r, -0.8, 0.8); });
            break;
          case 'bell':                                     // 알림 — 종
            poly([[16, 4], [23, 10], [24, 21], [27, 24], [5, 24], [8, 21], [9, 10]], G2);
            poly([[16, 4], [16, 24], [5, 24], [8, 21], [9, 10]], G1);
            circ(16, 27, 2.6, G2); circ(16, 4, 1.8, G1);
            break;
          case 'keys':                                     // 조작 — 자판
            P(3, 9, 26, 15, G2); P(3, 9, 26, 1.4, G1);
            for (let r = 0; r < 2; r++) for (let i = 0; i < 5; i++) P(5.5 + i * 4.6, 12 + r * 4.2, 3.4, 3, '#e8dcc0');
            P(9, 20.5, 14, 2.4, '#e8dcc0');
            break;
          case 'layout':                                   // 화면 구성 — 창 안의 칸 배치
            P(3, 5, 26, 22, G2); P(5, 7, 22, 18, '#2a2218');
            P(6, 8, 8, 3, G1); P(20, 8, 6, 5, '#7fb0d0'); P(21, 15, 5, 7, G1);
            for (let i = 0; i < 4; i++) P(9 + i * 3.4, 22, 2.6, 2.4, '#e8dcc0');
            break;
        }
        return;
      }
    }
  },
  pmenu(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 메뉴(일시정지) — 세 줄
        glow(16, 16, 12, '#d8a94b', .12);
        for (let i = 0; i < 3; i++) { P(7, 9 + i * 6, 18, 3, '#8c7651'); P(7, 9 + i * 6, 18, 1.4, '#c8aa70'); }
        return;
      }
    }
  },
  statui(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 능력치 — 올라가는 막대 셋.
        glow(16, 17, 12, '#d8a94b', .13);
        P(7, 19, 5, 9, '#8c7651');
        P(13.5, 13, 5, 15, '#c8aa70');
        P(20, 8, 5, 20, '#8c7651');
        P(6, 27.5, 20, 1.6, '#5c4930');                            // 밑줄
        return;
      }
    }
  },
  equipui(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 장비 칸의 빈 상태에서도 역할이 읽히도록, 갑옷과 방패를 겹친 작은 문장으로 그린다.
        glow(16, 16, 13, '#d8a94b', .15);
        poly([[9, 8], [23, 8], [26, 14], [23, 27], [9, 27], [6, 14]], '#8c7651');
        poly([[9, 8], [16, 8], [16, 27], [9, 27], [6, 14]], '#c8aa70');
        P(8, 16, 16, 2, '#5c4930'); P(15, 9, 2, 17, '#5c4930');
        poly([[20, 5], [28, 8], [27, 17], [24, 22], [20, 17]], '#5d7892');
        poly([[20, 6], [23.8, 8.3], [23.8, 19.8], [20, 17]], '#9fc4dc');
        P(21.5, 10, 1.5, 7, '#e8dcc0'); P(19, 12.5, 6.5, 1.5, '#e8dcc0');
        return;
      }
    }
  },
  trashui(H: ItemPaintKit) {
    const { g, s, rng, P, poly, circ, ell, stroke, glow } = H;
    { {
        // 파괴 행동임을 직관적으로 보이되, 공포감을 과하게 주지 않는 오래된 금속 휴지통.
        P(8, 10, 16, 18, '#6d4b47'); P(9.5, 11, 13, 16, '#9b6156');
        P(7, 7, 18, 4, '#b87466'); P(9, 5, 14, 2.5, '#7d514a');
        P(13, 3, 6, 2.5, '#b87466'); P(8, 27, 16, 2, '#4a302e');
        P(12, 13, 2, 10, '#5a3935'); P(17, 13, 2, 10, '#5a3935');
        P(21, 13, 1.5, 10, '#5a3935');
        P(10.5, 11.5, 2, 1.5, '#e6a28e');
        return;
      }
    }
  },
};
Object.assign(ITEM_PAINT, ItemPaintUI);
